import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
  hasError: false,
};

export default function cadastrousuariomaster(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@cadastrousuariomaster/FIND_CADASTROUSUARIOMASTER':
      case '@cadastrousuariomaster/UPDATE_CADASTROUSUARIOMASTER':
      case '@cadastrousuariomaster/DELETE_CADASTROUSUARIOMASTER':
      case '@cadastrousuariomaster/STORE_CADASTROUSUARIOMASTER':
      case '@cadastrousuariomaster/UNBLOCK_CADASTROUSUARIOMASTER':
      case '@cadastrousuariomaster/CADASTROUSUARIOMASTER_IN_REQUEST': {
        draft.loading = true;
        break;
      }


      case '@cadastrousuariomaster/FAILED_REQUEST': {
        draft.loading = false;
        draft.hasError = true;
        break;
      }

      case '@cadastrousuariomaster/SUCCESS_REMOVE': {
        draft.loading = false;
        draft.hasError = false;
        break;
      }

      case '@cadastrousuariomaster/CLEAN_ERRORS': {
        draft.hasError = false;
        break;
      }

      case '@cadastrousuariomaster/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.cadastrousuariomaster;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@cadastrousuariomaster/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.usuarioMasterVO;
        break;
      }

      case '@cadastrousuariomaster/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
